<!-- 
NoteModal.vue
功能：修改私人筆記視窗
作者：i9400538 陳博承
完成：2021-05-06
-->
<template>
  <div class="modal fade confirm" :class="{'is-open': open}">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h3 class="modal-title">編輯私人筆記</h3>
        </div>
        <div class="modal-body">
          <form class="form px-4">
            <h4 class="with-date-picker text-green d-inline-block">
              日期
              <div class="form-group ml-1 d-inline-block">
                <div class="d-inline-block">
                  <input type="text" class="form-control" v-model="noteDate" disabled />
                </div>
              </div>
            </h4>
            <div class="form-group">
              <h4 class="text-green">私人筆記</h4>
              <textarea
                class="form-control"
                cols="30"
                rows="3"
                v-model="noteText"
                maxlength="1000"
                @input="checkNote"
                @blur="checkNote"
              ></textarea>
            </div>
          </form>
        </div>
        <div class="modal-footer">
          <div class="text-right">
            <a @click="$emit('close')" class="btn btn-default">取消</a>
            <a @click.stop.prevent="submit()" class="btn btn-primary">儲存</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { commonMixin } from "@/mixins/common";
export default {
  name: "NoteModal",
  mixins: [commonMixin],
  props: {
    open: {
      type: Boolean,
      default: false
    },
    record: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  watch: {
    open: function(val) {
      if (val) {
        this.noteDate = this.record.NOTE_DATE || "";
        this.noteText = this.record.NOTE_STRING || "";
      }
    }
  },
  data() {
    return {
      noteDate: "",
      noteText: ""
    };
  },
  methods: {
    //檢查備註
    checkNote() {
      if (this.stringBytes(this.noteText, false, 1000) > 1000) {
        this.noteText = this.noteText.substring(
          0,
          this.stringBytes(this.noteText, true, 1000)
        );
      }
    },
    submit() {
      this.$emit("submit", this.noteDate, this.record.NOTE_TIME, this.noteText);
    }
  }
};
</script>